import createLendingBundle from './createBundle'
import whitepaper from './whitepaper.ja'

export default createLendingBundle(whitepaper)
